export const formatDate = (date, mode = 'default') => {
  let options = {};

  if (['default', 'date_only'].includes(mode)) {
    options = {
      ...options,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    };
  }
  if (['default', 'time_only'].includes(mode)) {
    options = {
      ...options,
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };
  }

  return new Intl.DateTimeFormat(navigator.language, options).format(date).replace(',', '');
};

export const getCurrentDate = () => {
  return new Date();
};

export const getOneDayBeforeDate = (date) => {
  const oneDayInMS = 86400000;
  return new Date(date.valueOf() - oneDayInMS);
};

export function isSameMonth(date, otherDate) {
  return date.getFullYear() === otherDate.getFullYear() && date.getMonth() === otherDate.getMonth();
}

export const isSameDay = (date, otherDate) => {
  return date.getDate() === otherDate.getDate() && isSameMonth(date, otherDate);
};
